import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { TenantProvider } from "@/context/TenantContext";
import { AuthProvider } from "@/context/AuthContext";
import PublicLayout from "@/components/public/PublicLayout";
import ProtectedRoute from "@/pages/auth/ProtectedRoute";

import Home from "@/pages/public/Home";
import Raffles from "@/pages/public/Raffles";
import RaffleDetail from "@/pages/public/RaffleDetail";
import Purchase from "@/pages/public/Purchase";
import Lookup from "@/pages/public/Lookup";
import Transparency from "@/pages/public/Transparency";
import { Winners, WinnerProfile } from "@/pages/public/Winners";
import LiveDraw from "@/pages/public/LiveDraw";
import About from "@/pages/public/About";
import { HowToParticipate, FAQ, Contact } from "@/pages/public/Info";

import Login from "@/pages/auth/Login";
import ResetPassword from "@/pages/auth/ResetPassword";
import AuthCallback from "@/pages/auth/AuthCallback";
import Dashboard from "@/pages/admin/Dashboard";
import AdminRaffles from "@/pages/admin/AdminRaffles";
import PaymentValidation from "@/pages/admin/PaymentValidation";
import { AdminWinners, Sellers, Reports, Audit, Branding } from "@/pages/admin/AdminMisc";
import AdminPolls from "@/pages/admin/AdminPolls";
import Poll from "@/pages/public/Poll";
import TeamUsers from "@/pages/admin/TeamUsers";
import SellerDashboard from "@/pages/seller/SellerDashboard";
import Saas from "@/pages/saas/Saas";

const Public = ({ children }) => <PublicLayout>{children}</PublicLayout>;

function AppRoutes() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/" element={<Public><Home /></Public>} />
      <Route path="/sorteos" element={<Public><Raffles /></Public>} />
      <Route path="/encuesta" element={<Public><Poll /></Public>} />
      <Route path="/sorteos/:id" element={<Public><RaffleDetail /></Public>} />
      <Route path="/comprar/:id" element={<Public><Purchase /></Public>} />
      <Route path="/consulta" element={<Public><Lookup /></Public>} />
      <Route path="/transparencia" element={<Public><Transparency /></Public>} />
      <Route path="/ganadores" element={<Public><Winners /></Public>} />
      <Route path="/ganadores/:id" element={<Public><WinnerProfile /></Public>} />
      <Route path="/sala" element={<LiveDraw />} />
      <Route path="/nosotros" element={<Public><About /></Public>} />
      <Route path="/como-participar" element={<Public><HowToParticipate /></Public>} />
      <Route path="/faq" element={<Public><FAQ /></Public>} />
      <Route path="/contacto" element={<Public><Contact /></Public>} />

      <Route path="/login" element={<Login />} />
      <Route path="/restablecer" element={<ResetPassword />} />
      <Route path="/admin" element={<ProtectedRoute min="analyst"><Dashboard /></ProtectedRoute>} />
      <Route path="/admin/sorteos" element={<ProtectedRoute min="admin"><AdminRaffles /></ProtectedRoute>} />
      <Route path="/admin/validacion" element={<ProtectedRoute min="validator"><PaymentValidation /></ProtectedRoute>} />
      <Route path="/admin/vendedores" element={<ProtectedRoute min="admin"><Sellers /></ProtectedRoute>} />
      <Route path="/admin/usuarios" element={<ProtectedRoute min="admin"><TeamUsers /></ProtectedRoute>} />
      <Route path="/admin/ganadores" element={<ProtectedRoute min="admin"><AdminWinners /></ProtectedRoute>} />
      <Route path="/admin/reportes" element={<ProtectedRoute min="analyst"><Reports /></ProtectedRoute>} />
      <Route path="/admin/auditoria" element={<ProtectedRoute min="supervisor"><Audit /></ProtectedRoute>} />
      <Route path="/admin/branding" element={<ProtectedRoute min="admin"><Branding /></ProtectedRoute>} />
      <Route path="/admin/encuestas" element={<ProtectedRoute min="admin"><AdminPolls /></ProtectedRoute>} />
      <Route path="/vendedor" element={<ProtectedRoute min="seller"><SellerDashboard /></ProtectedRoute>} />
      <Route path="/plataforma" element={<ProtectedRoute min="superadmin"><Saas /></ProtectedRoute>} />
      <Route path="*" element={<Public><div className="mx-auto max-w-lg px-6 py-32 text-center"><h1 className="text-5xl font-bold text-slate-900">404</h1><p className="mt-3 text-slate-500">Página no encontrada.</p></div></Public>} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <TenantProvider>
            <AppRoutes />
            <Toaster position="top-center" richColors />
          </TenantProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
